import { Stack } from "@mantine/core"
import { useForm } from "@mantine/form"
import { zod4Resolver } from "mantine-form-zod-resolver"
import { useTranslation } from "react-i18next"
import { z } from "zod"

import { LoginTextInput } from "~/pages/Auth/components/LoginTextInput"

import { LoginButton } from "./LoginButton"

const twoFactorSchema = z.object({
  token: z.string().min(1, "Token is required"),
  userId: z.string().min(1, "User ID is required"),
})

type TwoFactorFormProps = {
  onSubmit: (values: z.infer<typeof twoFactorSchema>) => Promise<void>
  userId: string
}

export const TwoFactorForm = ({ onSubmit, userId }: TwoFactorFormProps) => {
  const { t } = useTranslation("account")
  const form = useForm<z.infer<typeof twoFactorSchema>>({
    validate: zod4Resolver(twoFactorSchema),
    initialValues: {
      token: "",
      userId,
    },
  })

  return (
    <form onSubmit={form.onSubmit(onSubmit)} style={{ width: "100%" }}>
      <Stack>
        <LoginTextInput
          name="token"
          placeholder={t("login.placeholders.token")}
          type="text"
          label="Fill the generated code"
          autoFocus
          required
          autoComplete="one-time-code"
          {...form.getInputProps("token")}
        />
        <LoginButton type="submit" disabled={!form.isValid()}>
          Login
        </LoginButton>
      </Stack>
    </form>
  )
}
